declare namespace $ {

	type $mol_string__hint_giper_baza_land_rights_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_giper_baza_land_rights_2 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['add_key'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_giper_baza_land_rights_3 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['add_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__enabled_giper_baza_land_rights_4 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['enabled'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_button_minor__click_giper_baza_land_rights_5 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['add_commit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__enabled_giper_baza_land_rights_6 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__sub_giper_baza_land_rights_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_giper_baza_land_rights_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_select__hint_giper_baza_land_rights_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_giper_baza_land_rights_10 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['gift_rate'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__enabled_giper_baza_land_rights_11 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_select__Filter_giper_baza_land_rights_12 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_giper_baza_land_rights_13 = $mol_type_enforce<
		({ 
			'0': string,
			'1': string,
			'2': string,
			'3': string,
			'4': string,
			'5': string,
			'6': string,
			'7': string,
			'8': string,
			'9': string,
			'A': string,
			'B': string,
			'C': string,
			'D': string,
			'E': string,
			'F': string,
		}) 
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__hint_giper_baza_land_rights_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_giper_baza_land_rights_15 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['gift_tier'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__Filter_giper_baza_land_rights_16 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_select__dictionary_giper_baza_land_rights_17 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['tier_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__enabled_giper_baza_land_rights_18 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['enabled'] >
		,
		ReturnType< $mol_select['enabled'] >
	>
	type $mol_avatar__id_giper_baza_land_rights_19 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['peer_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $giper_baza_link_chip__param_giper_baza_land_rights_20 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['link_param'] >
		,
		ReturnType< $giper_baza_link_chip['param'] >
	>
	type $giper_baza_link_chip__link_giper_baza_land_rights_21 = $mol_type_enforce<
		ReturnType< $giper_baza_land_rights['peer_link'] >
		,
		ReturnType< $giper_baza_link_chip['link'] >
	>
	type $giper_baza_link_chip__sub_giper_baza_land_rights_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $giper_baza_link_chip['sub'] >
	>
	type $mol_view__sub_giper_baza_land_rights_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $giper_baza_land_rights extends $mol_list {
		add_key( next?: string ): string
		add_commit( next?: any ): any
		enabled( ): boolean
		Add_key( ): $mol_string
		Add_commit_icon( ): $mol_icon_plus
		Add_commit( ): $mol_button_minor
		Add( ): $mol_view
		gift_rate( id: any, next?: string ): string
		Gift_rate( id: any): $mol_select
		gift_tier( id: any, next?: string ): string
		tier_options( ): ({ 
			'deny': string,
			'read': string,
			'post': string,
			'pull': string,
			'rule': string,
		}) 
		Gift_tier( id: any): $mol_select
		link_param( ): string
		peer_link( id: any): $giper_baza_link
		peer_id( id: any): string
		Gift_avatar( id: any): $mol_avatar
		Gift_name( id: any): $giper_baza_link_chip
		Gift( id: any): $mol_view
		gifts( ): readonly(any)[]
		land( ): $giper_baza_land
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=rights.view.tree.d.ts.map